// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a35d2822","60":"25d5f9c3","202":"da8f7186","264":"f11f0ce7","467":"5131eb1a","557":"9c1e9b70","585":"bafb452d","595":"43bde9be","596":"b5f5f621","722":"561eaec8","757":"923a6751","895":"82ddd34a","916":"4522ce73","919":"4df5f9e5","970":"69115af7"}[chunkId] + ".chunk.js";
};